export const CHANGELOG_LAST_SEEN_KEY = 'changelog:lastSeenAt'

/**
 * The ISO date of the newest changelog entry the user has acknowledged, or null
 * if they have never seen one. Stored per-device in localStorage (no server
 * persistence by design — see plan).
 */
export function getLastSeenAt(): string | null {
    if (typeof window === 'undefined') return null
    return window.localStorage.getItem(CHANGELOG_LAST_SEEN_KEY)
}

export function setLastSeenAt(date: string): void {
    if (typeof window === 'undefined') return
    window.localStorage.setItem(CHANGELOG_LAST_SEEN_KEY, date)
}
